<template>
    <div class="tw-flex tw-flex-col lg:tw-flex-row tw-pt-3 lg:tw-pt-6 tw-pb-12 tw-border-0 md:tw-border-t md:tw-border-b md:tw-border-dark-grey">
        <div class="tw-flex tw-flex-col tw-w-full lg:tw-w-1/6 tw-border-b tw-border-dark-grey lg:tw-border-0 tw-mb-10 lg:tw-mb-0">
            <div class="h7 pb-2">Create Crew Alert</div>
        </div>
        <div class="tw-flex tw-flex-col tw-w-full lg:tw-w-5/6 tw-border-b tw-border-dark-grey md:tw-border-0">
            <v-btn @click="$inertia.visit(route('crewalerts.index'))" class="main-btn tw-mb-4 tw-w-72">Return to Crew Alert List</v-btn>
            <div class="tw-mt-4 tw-mb-8 lg:tw-w-2/3">
                This form is available 24/7 to create crew alerts.  Members will be notified and can respond directly.  Trainees are booked through the Trainee Coordinator during office hours.  Please contact us.  Please note that membership listings may not be used for direct sales or marketing solicitation without the express written consent of the individual member.
            </div>
            <v-form
                v-model="inputs_valid"
                :action="route('crewalerts.store.preview', true).url()"
                method="post"
                ref="frm_new_crew_alert"
                class="px-0 mx-0 lg:tw-w-2/3"
                v-on:submit.prevent
                autocomplete="off"
            >
                <input type="hidden" autocomplete="false">
                <v-autocomplete class=""
                                label="Province *"
                                :items="valuelists.PROVINCES"
                                v-model="record.province_id"
                                :rules="[rules.required]"
                                :error-messages="errors?.province_id"
                                outlined
                                dense
                                clearable
                ></v-autocomplete>

                <v-autocomplete class=""
                                label="Job Category *"
                                :items="valuelists.TITLE_FUNCTIONS_WEBSITE"
                                v-model="record.title_function_id"
                                :rules="[rules.required]"
                                :error-messages="errors?.title_function_id"
                                outlined
                                dense
                                clearable
                ></v-autocomplete>

                <v-autocomplete class=""
                                label="Skill"
                                :items="valuelists.SKILLS_GROUPED"
                                v-model="record.skill_id"
                                :error-messages="errors?.skill_id"
                                outlined
                                dense
                                clearable
                ></v-autocomplete>
                <div class="">
                    <h6 class="tw-font-normal tw-pb-2">Date Required</h6>
                    <div class="tw-flex tw-flex-row tw-gap-2">
                        <v-text-field
                            v-model="record.date_required_temp"
                            :rules="[rules.required]"
                            :error-messages="errors?.date_required_temp"
                            dense
                            color="primary"
                            label="Date Required"
                            display-label="Date Required"
                            clearable
                        />
                    </div>

                </div>

                <v-autocomplete class=""
                                label="Production *"
                                :items="valuelists.ACTIVE_WORKABLE_PRODUCTIONS"
                                :filter="productionListFilter"
                                v-model="record.production_id"
                                :rules="[rules.required]"
                                :error-messages="errors?.production_id"
                                outlined
                                dense
                                clearable
                ></v-autocomplete>

                <div class="">
                    <v-text-field
                        v-model="record.location"
                        :error-messages="errors?.location"
                        label="Location"
                        dense
                    ></v-text-field>
                </div>

                <v-radio-group v-model="record.unit" row>
                    <v-radio
                        v-for="unit in valuelists.UNITS"
                        :error-messages="errors?.unit"
                        :key="unit.value"
                        :label="unit.text"
                        :value="unit.value"
                    ></v-radio>
                </v-radio-group>

                <div class="">
                    <v-text-field
                        v-model="record.call_time"
                        :error-messages="errors?.call_time"
                        label="Call Time"
                        dense
                    ></v-text-field>
                </div>

                <div class=" pb-6">
                    <v-file-input
                        v-model="new_file_to_upload"
                        :error-messages="errors?.call_sheet_file"
                        label="Upload Call Sheet"
                        :hint="record.call_sheet_file ? record.call_sheet_file : ''"
                        outlined
                        dense
                        clearable
                        hide-details="auto"
                    ></v-file-input>
                </div>

                <hr class="mt-0 mb-4 border-dark-grey w-full">
                <h6 class="tw-font-normal tw-pb-2">Crew Contact</h6>
                <div class=" pb-6">
                    <v-textarea
                        v-model="record.crew_contact"
                        :error-messages="errors?.crew_contact"
                        label="Name, Position, Email/Phone"
                        auto-grow
                        hide-details="auto"
                        outlined
                        dense
                        clearable
                        rows="3"
                    ></v-textarea>
                </div>

                <hr class="mt-0 mb-4 border-dark-grey w-full">
                <h6 class="tw-font-normal tw-pb-2">Contract</h6>
                <div class=" pb-6">
                    <v-textarea
                        v-model="record.contract"
                        :error-messages="errors?.contract"
                        label="Full Contract, Tiered Agreement, Dispensation"
                        auto-grow
                        hide-details="auto"
                        outlined
                        dense
                        clearable
                        rows="3"
                    ></v-textarea>
                </div>

                <hr class="mt-0 mb-4 border-dark-grey w-full">
                Production Info

                <div class="">
                    <v-text-field
                        v-show="!!production_title"
                        :value="production_title"
                        disabled
                        :error-messages="errors?.production_title"
                        label="Title"
                        dense
                    ></v-text-field>
                </div>

                <div class="">
                    <v-text-field
                        v-model="record.company_name"
                        :error-messages="errors?.company_name"
                        label="Company Name"
                        dense
                    ></v-text-field>
                </div>

                <div class="">
                    <v-text-field
                        v-model="record.address"
                        :error-messages="errors?.address"
                        label="Address"
                        dense
                    ></v-text-field>
                </div>

                <div class="">
                    <v-text-field
                        v-model="record.phone"
                        :error-messages="errors?.phone"
                        label="Phone"
                        dense
                    ></v-text-field>
                </div>

                <div class="">
                    <v-text-field
                        v-model="record.email"
                        :error-messages="errors?.email"
                        label="Email"
                        dense
                    ></v-text-field>
                </div>

                <hr class="mt-0 mb-4 border-dark-grey w-full">
                Additional Notes

                <div class=" pb-6">
                    <v-textarea
                        v-model="record.notes"
                        :error-messages="errors?.notes"
                        label="Additional Notes"
                        auto-grow
                        hide-details="auto"
                        outlined
                        dense
                        clearable
                        rows="3"
                    ></v-textarea>
                </div>

                <div class="">
                    <v-btn
                        type="submit"
                        @click="submitForm"
                        :disabled="!inputs_valid"
                        class="main-btn tw-w-full md:tw-w-48"
                    >
                        Continue
                    </v-btn>
                </div>
            </v-form>
        </div>
    </div>
</template>

<script>
    import SmartTable from "@/Generic/SmartTable";
    import AppLayoutSidebarNav from "@/Layouts/AppLayoutSidebarNav.vue";
    import CrewAlertsFilters from "@/Pages/ExternalPages/CrewAlertsFilters.vue";
    import DatePicker from "@/Generic/DatePicker.vue";

    export default {
        name: "CrewAlertsCreate",
        layout: (h, page) => {
            return h(AppLayoutSidebarNav, [
                page
            ])
        },
        components: {
            DatePicker,
            CrewAlertsFilters,
            SmartTable,
        },
        props: {
            'constants': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
            'valuelists': {
                type: Object,
                required: false,
                default: function () {
                    return undefined
                }
            },
        },
        data() {
            return {
                inputs_valid: null,
                record: {},
                new_file_to_upload: null,
                errors: {},
                rules: {
                    required: value => !!value || 'Required',
                },
            }
        },
        computed: {
            payload() {
                let payload = new FormData()
                if (!!this.record.province_id) payload.append("province_id", this.record.province_id)
                if (!!this.record.title_function_id) payload.append("title_function_id", this.record.title_function_id)
                if (!!this.record.skill_id) payload.append("skill_id", this.record.skill_id)
                if (!!this.record.date_required_temp) payload.append("date_required_temp", this.record.date_required_temp)
                if (!!this.record.production_id) payload.append("production_id", this.record.production_id)
                if (!!this.record.location) payload.append("location", this.record.location)
                if (!!this.record.unit) payload.append("unit", this.record.unit)
                if (!!this.record.call_time) payload.append("call_time", this.record.call_time)
                if (!!this.new_file_to_upload) payload.append("call_sheet_file", this.new_file_to_upload)
                if (!!this.new_file_to_upload) payload.append("call_sheet", this.call_sheet_status)
                if (!!this.record.crew_contact) payload.append("crew_contact", this.record.crew_contact)
                if (!!this.record.contract) payload.append("contract", this.record.contract)
                if (!!this.record.company_name) payload.append("company_name", this.record.company_name)
                if (!!this.record.address) payload.append("address", this.record.address)
                if (!!this.record.phone) payload.append("phone", this.record.phone)
                if (!!this.record.email) payload.append("email", this.record.email)
                if (!!this.record.notes) payload.append("notes", this.record.notes)

                return payload
            },
            call_sheet_status() {
                return !!this.new_file_to_upload ? this.constants?.CALL_SHEET_STATUSES?.CALL_SHEET_STATUS_ATTACHED : this.constants?.CALL_SHEET_STATUSES?.CALL_SHEET_STATUS_TO_FOLLOW
            },

            values_regions() {
                if (this?.constants?.MEMBER_REGIONS) {
                    return Object.values(this.constants?.MEMBER_REGIONS)
                }
                return []
            },
            values_categories() {
                if (this?.valuelists?.TITLE_FUNCTIONS) {
                    return Object.values(this.valuelists?.TITLE_FUNCTIONS)
                }
                return []
            },
            values_skills() {
                if (this?.valuelists?.SKILLS_GROUPED) {
                    return Object.values(this.valuelists?.SKILLS_GROUPED)
                }
                return []
            },
            production_title() {
                if (!this.record.production_id) return null
                if (this.valuelists.ACTIVE_WORKABLE_PRODUCTIONS.find(prod => prod.value === this.record.production_id)?.alt) {
                    return `${this.valuelists.ACTIVE_WORKABLE_PRODUCTIONS.find(prod => prod.value === this.record.production_id)?.text} - ${this.valuelists.ACTIVE_WORKABLE_PRODUCTIONS.find(prod => prod.value === this.record.production_id)?.alt}`
                } else {
                    return this.valuelists.ACTIVE_WORKABLE_PRODUCTIONS.find(prod => prod.value === this.record.production_id)?.text
                }
            },
        },
        methods: {
            async submitForm () {
                axios.post(route('crewalerts.store.preview', true), this.payload)
                    .then((response) => {
                        this.$emit('response-received', response, this.payload)
                    })
                    .catch((error) => {
                        if( error?.response ) {
                            this.$root.snackbar.error(error.response.data.message)
                            this.errors = error.response?.data?.errors
                        } else {
                            console.log(error)
                            this.$root.snackbar.error(error)
                        }
                    })
            },
            goToDetails(item) {
                this.$inertia.visit(route(`crewalerts.show`, item).url())
            },
            resetValidation () {
                this.$refs.frm_new_crew_alert.resetValidation()
                this.errors = null
            },
            productionListFilter(item, queryText, itemText) {
              return (item.text.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1) || (item.alt?.toLocaleLowerCase().indexOf(queryText.toLocaleLowerCase()) > -1)
            },
        },

        watch: {
            record: {
                handler(newValue, oldValue) {
                    this.resetValidation()
                    // ToDo: Re-enable the is_dirtification here after figuring out how to handle $inertia.visit accordingly
                    // this.$root.is_dirty = true
                },
                deep: true,
                immediate: false
            },
            new_file_to_upload(newValue, oldValue) {
                this.resetValidation()
            },
            'record.phone'(newValue, oldValue) {
                if (newValue !== '') {
                    this.$set(this.record, 'phone', this.$root.formatPhoneDisplay(newValue))
                }
            },
        },
    }
</script>

